<template>
  <Teleport to="body">
    <div class="fullpage-form">
      <div class="fullpage-header">
        <button class="fullpage-back" @click="$emit('close')" title="Retour" aria-label="Retour">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 12H5"/><polyline points="12 19 5 12 12 5"/>
          </svg>
          Retour
        </button>
        <h1 class="fullpage-title"><slot name="title">Formulaire</slot></h1>
      </div>
      <div class="fullpage-body">
        <div class="fullpage-content" :class="{ 'fullpage-content--wide': wide }">
          <slot />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { Teleport } from 'vue';

defineProps<{
  wide?: boolean;
}>();

defineEmits<{
  close: [];
}>();
</script>

<style scoped>
.fullpage-form {
  position: fixed;
  inset: 0;
  background: var(--color-bg-primary);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  animation: pageIn 0.2s ease;
}

.fullpage-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-md) var(--spacing-xl);
  background: var(--color-bg-secondary);
  border-bottom: 1px solid var(--color-border-light);
  flex-shrink: 0;
}

.fullpage-back {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  background: none;
  border: none;
  color: var(--color-primary);
  cursor: pointer;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-md);
  transition: background var(--transition-fast);
}

.fullpage-back:hover {
  background: var(--color-bg-tertiary);
}

.fullpage-title {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.fullpage-body {
  flex: 1;
  overflow-y: auto;
  padding: var(--spacing-xl);
}

.fullpage-content {
  max-width: 640px;
  margin: 0 auto;
}

.fullpage-content--wide {
  max-width: 1000px;
}

@keyframes pageIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
